import { render, staticRenderFns } from "./Journaleintrag.vue?vue&type=template&id=96221a5a"
import script from "./Journaleintrag.vue?vue&type=script&lang=js"
export * from "./Journaleintrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports